<div class="container">
    <div *ngIf="unusedPermitTypes.length == 0" dwRow>
        <h2>All assigned permits have been added.</h2>
    </div>
    <ng-container *ngIf="unusedPermitTypes.length > 0">
        <div dwRow>
            <div dwCol="12">
                <label class="label">Permit Types</label>
                <div *ngFor="let lookupItem of unusedPermitTypeLookupItems">
                    <div>  
                        <input disabled
                            class="form-check-input" 
                            type="checkbox" 
                            [(ngModel)]="alwaysChecked">
                        <label class="form-check-label" for="inlineCheckbox1">{{ lookupItem.Display }}</label>
                    </div> 
                </div>
            </div>
        </div>
        <div dwCol="12">
            <label class="label">Assigned To</label>
            <dw-auto-complete-lookup 
                [(ngModel)]="assignedTo" 
                [lookupId]="activeUserLookupId"
                useServerSearch="true">
            </dw-auto-complete-lookup>
        </div>
        <div dwCol="12">
            <label class="label">Initial Status</label>
            <dw-search-select-lookup 
                [(ngModel)]="workFlowStatusId"
                [lookupId]="workflowStatusLookupId">
            </dw-search-select-lookup>
        </div>
    </ng-container>
</div>